import React, { useMemo, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { API_BASE_URL } from '../config/api'
import toast from 'react-hot-toast'

const ResetPassword = () => {
  const navigate = useNavigate()
  const [params] = useSearchParams()
  const token = useMemo(() => (params.get('token') || '').trim(), [params])
  const [password, setPassword] = useState('')
  const [confirm, setConfirm] = useState('')
  const [submitting, setSubmitting] = useState(false)

  const handleSubmit = async (e) => {
    e.preventDefault()
    if (submitting) return
    if (!token) {
      toast.error('El enlace de restablecimiento no es válido')
      return
    }
    if (password.length < 8) {
      toast.error('La contraseña debe tener al menos 8 caracteres')
      return
    }
    if (password !== confirm) {
      toast.error('Las contraseñas no coinciden')
      return
    }

    setSubmitting(true)
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      })
      const data = await response.json().catch(() => ({}))
      if (response.ok && data.success === true && data.password_changed === true) {
        toast.success(data.message || 'Contraseña actualizada. Ya puedes iniciar sesión.')
        navigate('/login', { replace: true })
      } else {
        toast.error(data.detail || data.message || 'No se pudo restablecer la contraseña')
      }
    } catch (err) {
      toast.error('Error de conexión. Inténtalo de nuevo.')
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="auth-body">
      <div className="auth-container">
        <div className="auth-card">
          <h1 style={{ color: '#C8202F', marginBottom: '0.5rem' }}>Restablecer contraseña</h1>
          <p style={{ color: '#666', marginBottom: '1.5rem' }}>
            Define una nueva contraseña. Este enlace es de un solo uso.
          </p>
          {!token ? (
            <p style={{ color: '#C8202F' }}>Falta el token en el enlace. Solicita un nuevo restablecimiento.</p>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="newPassword">Nueva contraseña</label>
                <input
                  id="newPassword"
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  disabled={submitting}
                  autoComplete="new-password"
                  required
                  minLength={8}
                />
              </div>
              <div className="form-group">
                <label htmlFor="confirmPassword">Confirmar contraseña</label>
                <input
                  id="confirmPassword"
                  type="password"
                  value={confirm}
                  onChange={(e) => setConfirm(e.target.value)}
                  disabled={submitting}
                  autoComplete="new-password"
                  required
                  minLength={8}
                />
              </div>
              <button type="submit" className="btn-primary" disabled={submitting}>
                {submitting ? 'Guardando...' : 'Guardar contraseña'}
              </button>
            </form>
          )}
          <button
            type="button"
            className="forgot-password"
            style={{ marginTop: '1rem' }}
            onClick={() => navigate('/login')}
            disabled={submitting}
          >
            Volver al inicio de sesión
          </button>
        </div>
      </div>
    </div>
  )
}

export default ResetPassword
